export const settingsTabPanelSx = { height: 'calc(100vh - 200px)' } as const;
